import NewsPage from 'views/news/NewsPage';

export default NewsPage;
